import { HTMLAttributes } from 'react'
import styled, { css } from 'styled-components'
import {
  space,
  layout,
  position,
  flexbox,
  grid,
  SpaceProps,
  LayoutProps,
  FlexboxProps,
  GridProps,
  PositionProps,
  opacity,
  OpacityProps,
  PaddingProps,
  padding,
  fontSize,
  FontSizeProps,
  border,
  BorderProps,
} from 'styled-system'

export type TBox = BorderProps & SpaceProps & FontSizeProps & LayoutProps & FlexboxProps & GridProps & PositionProps & OpacityProps & PaddingProps & HTMLAttributes<HTMLDivElement>

export const withBox = css`
  ${space}
  ${layout}
  ${flexbox}
  ${grid}
  ${position}
  ${opacity};
  ${padding};
  ${fontSize};
  ${border}
`

const Box = styled.div<TBox>`
  ${withBox}
`

export default Box